import { call, put } from 'redux-saga/effects';
import { onGetVehicleDataFailure, onGetVehicleDataSuccess, onRecievedVehicleData } from '../actions';
import { normalizeVehicleData, VehicleService } from '../services';
import { updateVehicleSelectionMethodAction, VehicleSelectionMethod } from "../../vehicleInfo";
/**
 * Saga to handle the request to get job vehicle and
 * notify other vehicle associated domains to fill state like vehicle color, attributes, options etc.
 * @param action
 * @param vehicleService
 */
export function* getJobVehicleSaga(action, 
/*istanbul ignore next*/
vehicleService = VehicleService.getInstance()) {
    try {
        const result = yield call({
            fn: vehicleService.GetJobVehicleData,
            context: vehicleService
        }, action.payload.jobId);
        //dispatch an action to set vehicle selection method in vehicleInfo
        yield put(updateVehicleSelectionMethodAction(result.vehicleSelectionMethod
            ? VehicleSelectionMethod[result.vehicleSelectionMethod]
            : VehicleSelectionMethod.VinDecode));
        //success action to notify store to referesh vehicle data
        yield put(onGetVehicleDataSuccess(normalizeVehicleData(result)));
        //vehicle recieved action to notify all other dependent listner to fill their respective state
        yield put(onRecievedVehicleData(result));
    }
    catch (exception) {
        const errorStatus = exception &&
            exception
                .toString()
                .split(':')[0]
                .trim();
        yield put(onGetVehicleDataFailure(errorStatus));
    }
}
//# sourceMappingURL=getJobVehicleSaga.js.map